import { render, staticRenderFns } from "./ThemConfigurator.vue?vue&type=template&id=16a4b2dd"
import script from "./ThemConfigurator.vue?vue&type=script&lang=js"
export * from "./ThemConfigurator.vue?vue&type=script&lang=js"
import style0 from "./ThemConfigurator.vue?vue&type=style&index=0&id=16a4b2dd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports